import { Heading } from "../../global";
import { Pulse } from "./styles";

export const Target = (props) => {
  const { target } = props;
  return <Heading {...props}>{target}</Heading>;
};

export const TargetWithAnimation = (props) => {
  const { $trigger, target } = props;
  return (
    <Pulse key={$trigger} {...props}>
      {target}
    </Pulse>
  );
};
